/**
 * Strings and storage keys ported verbatim from the old app. The error text in
 * particular is user-visible and reproduced character-for-character from
 * utils/utils.js:getErrorMessage — support staff recognise it.
 */

/**
 * utils.js:74-75. Two spaces after "error." and a trailing space after the colon, both
 * as in the original — and note the original's spelling of "Opps"/"Occured". The full
 * message is assembled as `${GENERIC_ERROR_PREFIX} ${requestId}` (utils.js writes
 * `value + " " + requestId`), which yields two spaces before the id as well. Preserved
 * exactly; support staff match on this string.
 */
export const GENERIC_ERROR_PREFIX =
  'Opps! An Unexpected Error Occured. Please Reach out to EAG Support Team with a Screenshot of this error.  Request ID : ';

/** utils.js:111 — the TOKEN_NOT_ELIGIBLE_FOR_REFRESH branch. */
export const SESSION_EXPIRED_MESSAGE =
  'Sorry your session expired. Please refresh the page to continue';

/** utils.js:84 — the 404 branch. */
export const NO_DATA_MESSAGE = 'No Data To Display';

/** utils.js:78 — the placeholder when no RequestID could be scraped. */
export const NOT_APPLICABLE = 'Not Applicable';

/**
 * Thrown when an expired token cannot be refreshed because the session came from
 * Empower (?source=empower). utils.js:36.
 */
export const TOKEN_NOT_ELIGIBLE_FOR_REFRESH = 'TOKEN_NOT_ELIGIBLE_FOR_REFRESH';

/* ----------------------------- storage keys ----------------------------- */

/**
 * Fallback until /api/auth-config resolves. The old app read this from
 * authConfiguration.tokenCacheKey, which is "access_token" in every environment file
 * except property-envdev1.json ("authToken") — so it is configurable, not hardcoded.
 */
export const DEFAULT_TOKEN_CACHE_KEY = 'access_token';
export const LOGGED_USER_STORAGE_KEY = 'logged-user';
export const ID_TOKEN_STORAGE_KEY = 'idToken';

/** feedback.jsx — the cookie that suppresses the feedback prompt once dismissed. */
export const FEEDBACK_COOKIE_NAME = 'chk_te_feedback';
